<template>
   <div class="crud-wrapper">
      <crud :form-component="BranchForm"
            alwaysUpdate="managerId"
            :grid-columns="gridColumns" obj="company">
      </crud>
   </div>
</template>

<script>
   import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';

   import BranchForm from './BranchForm';

   export default PageClass.extend({
      name: 'Partners',

      data () {
         return {
            BranchForm,

            gridColumns: [
               {
                  dataField: 'storeName',
                  caption: 'Nome',
                  minWidth: 150
               },
               {
                  dataField: 'max_pa_qty',
                  caption: 'PAs',
                  dataType: 'number',
                  format: { type: 'fixedPoint', precision: 0 },
                  width: 90
               },
               {
                  dataField: 'managerName',
                  caption: 'Gestor',
                  minWidth: 120
               },
               {
                  dataField: 'phone',
                  caption: 'Fone',
                  minWidth: 120
               },
               {
                  dataField: 'whatsapp',
                  caption: 'WhatsApp',
                  minWidth: 120
               },
               {
                  dataField: 'city',
                  caption: 'Cidade'
               },
               {
                  dataField: 'state',
                  caption: 'Estado',
                  width: 90
               }
            ]
         };
      }
   });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Branches.vue